<template>
    <div class="ng-scope">

        <!-- SHOW LOGIN FORM -->
        <div tabindex="-1" role="dialog" class="modal fade ng-isolate-scope in"
             style="z-index: 1050; display: block;" v-if="showLogin">
            <div class="modal-dialog ">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">{{ __('dialog_login.title') }}</h3>
                    </div>
                    <div class="modal-body">
                        <div><p>
                            {{ __('dialog_login.text') }}
                        </p></div>    
                        <form novalidate="" name="loginform" class="form-horizontal">
                            <dl class="form" id="loginRegisterForm">

                                <div class="errorMessages" v-if="error">
                                    <span class="wglErrorMessage">
                                        {{ __('dialog_login.error') }}
                                    </span>
                                </div>

                                <div class="label-input">
                                    <dt>
                                        <label for="email" class="col-sm-2 control-label labelText">
                                            {{ __('dialog_login.email') }}
                                        </label>
                                    </dt>
                                    <dd>
                                        <input type="email" id="email" name="email" required="" autofocus=""
                                            v-model="email" class="inputText">
                                    </dd>
                                </div>

                                <div class="label-input">
                                    <dt>
                                        <label for="email" class="col-sm-2 control-label labelText">
                                            {{ __('dialog_login.password') }}
                                        </label>
                                    </dt>
                                    <dd>
                                        <input type="password" id="password" name="password" required=""
                                            minlength="5" v-model="password" class="inputText">
                                    </dd> 
                                </div>

                                <dt>
                                    <a href="" @click.stop.prevent="showResetPassword">
                                    <span style="font-size:12px">
                                            {{ __('dialog_login.forgotpassword') }}
                                    </span></a>
                                </dt>

                                <div style="margin-top: 20px;">
                                    <button class="buttonSubmit btn-primary" style="margin-bottom: 20px; text-align: center;" type="button" :disabled="!validEmail || password.length <= 6"
                                            @click="doLogin">
                                        {{ __('dialog_login.btn_ok') }}
                                    </button>
                                </div>
                            </dl>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div tabindex="-1" role="dialog" class="modal fade ng-isolate-scope in"
             style="z-index: 1050; display: block;" v-if="showReset">
            <div class="modal-dialog ">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Passwort Reset</h3>
                    </div>
                    <div class="modal-body">
                        <div><p>
                            <span v-if="$store.language === 'de'">
                                Geben Sie ihre Email Adresse ein, um Ihr Passwort zurückzusetzen.</span>
                            <span v-else>
                                Please enter you email address to reset your password.
                            </span>
                        </p></div>
                        <div class="errorMessages" v-if="error">
                                    <span class="wglErrorMessage">
                                        {{errorMessage}}
                                    </span>
                        </div>
                        <form novalidate="" name="loginform" class="form-horizontal">
                            <dl class="form" id="loginRegisterForm">
                                <div class="label-input">
                                    <dt>
                                        <label for="email" class="col-sm-2 control-label">
                                            {{ __('dialog_login.email') }}
                                        </label>
                                    </dt>
                                    <dd>
                                        <input type="email" id="email" name="email" required="" autofocus=""
                                            v-model="email">
                                    </dd>
                                </div>

                                <div class="modal-footer" style="display: flex; flex-direction: row;">
                                    <div>
                                        <button class="buttonSubmit" type="button" :disabled="!validEmail"
                                                    @click="doReset">Reset</button>
                                    </div>    
                                </div>
                            </dl>
                            <dt>
                                <a href="" @click.stop.prevent="showLoginModal">{{__('common.button_back')}}</a>
                            </dt>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div tabindex="-1" role="dialog" class="modal fade ng-isolate-scope in"
             style="z-index: 1050; display: block;" v-if="showConfirmReset">
            <div class="modal-dialog ">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Passwort Reset</h3>
                    </div>
                    <div class="modal-body">
                        <p v-if="$store.language === 'de'">Wir hab Ihnen eine Email mit Ihren Zugangsdaten zugesendet.</p>
                        <p v-else>We sent you an email with your login information.</p>
                    </div>
                    <div class="modal-footer">
                        <button class="buttonReset" type="button" @click="showConfirmReset = false">
                           Ok
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <dt v-if="showLogin" class="signup-link">
            <span style="cursor: pointer;">{{ __('dialog_login.notamember') }}</span> <a href="" @click.stop.prevent="showLogin = false; showReset=false; emitLoginStatus();"> {{ __('dialog_login.signupnow') }}</a>
        </dt>

        <dt v-if="!showLogin && !showReset" class="signup-link" style="margin-bottom: 40px;">
            <span style="cursor: pointer;">{{ __('dialog_login.alreadymember') }}</span> <a href="" @click.stop.prevent="showLogin = true; emitLoginStatus();"> {{ __('dialog_login.loginnow') }}</a>
        </dt>

       
        <div class="modal-backdrop fade in" style="z-index: 1040;" v-if="showLogin || showReset"></div>
    </div>
</template>

<script>
import Lang from "../mixins/Lang";
import Account from "../api/Account";
import Api from '../api/Api';

export default {
        name: "Login",

        props : ['matchedEmail'],

        mixins: [Lang],

        created() {

        },

        watch : {
            matchedEmail () {
                if(this.showLogin === false) {
                    this.email = this.matchedEmail;
                }
            }
        },

        methods: {

            emitLoginStatus() {
                this.$emit('login-register-status', this.showLogin);
            },

            showResetPassword() {
                this.showReset = true;
                this.showLogin = false;
            },

            showLoginModal() {
                this.showReset = false;
                this.showLogin = true;
                this.emitLoginStatus();
            },

            doLogin() {
                Account.login(this.email, this.password).then(function (response) {
                    this.$emit('loginSuccess', response.data.contact);
                    this.showLogin = false;
                    this.error = false;
                }.bind(this)).catch((error) => {
                    // eslint-disable-next-line
                    console.log(error);
                    this.error = true;
                });
            },

            doReset () {
                this.error = "";
                this.errorMessage = "";
                Api.post('interessents/reset', { email : this.email}).then(({data}) => {
                    if(!data.success) {
                        this.error = true;
                        this.errorMessage = "Fehler beim zurücksetzen des Passworts";
                    } else {
                        this.showConfirmReset = true;
                        this.showReset = false;
                    }
                }).catch(() => {
                    this.error = true;
                    this.errorMessage = "Fehler beim zurücksetzen des Passworts";
                });
            }
        },

        computed: {
            validEmail: function () {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(this.email);
            }
        },

        data() {
            return {
                showLogin: true,
                showReset: false,
                showConfirmReset : false,
                error: false,
                errorMessage  : "",
                email: '',
                password: ''
            }
        }
    }
</script>

<style lang="scss">
    div.ng-scope .modal-dialog {
        width: 650px;
    }

    .signup-link {
        margin-top: 30px;
        color: #6f4024;
    }


    .signup-link a{
        color: #bca46e;
        text-decoration: none;
    }

    form input {
        width: 300px;
    }

    #loginRegisterForm {
        /*display: flex;
        flex-direction: column;*/
        align-items: center;
    }

    .label-input {
        text-align: left;
    }


</style>
